import React, { useState, useEffect } from "react";
import RegInput from "./RegInput";
import { HPIRegCheck } from "../helpers";
import { useSelector, useDispatch } from "react-redux";
import {
  getAppraisalData,
  getSourceSystemContent
} from "../../store/selectors";
import { appraisalSlice } from "../../store/slices/Appraisal";
import {
  getLocalStorage,
} from "../../sessionAndLocalStorage";
import { useNavigate } from "react-router-dom";

export default function RegInputContainer() {
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(appraisalSlice.actions.removeVehicle());
    dispatch(appraisalSlice.actions.removeQuestions());
  }, [dispatch]);

  const showPrivacyStatement = useSelector(
    getSourceSystemContent
  ).showPrivacyStatement;

  const { appraisalSessionId } = useSelector(getAppraisalData);

  const hasLettersAndNumbers = new RegExp("^(?=.*[a-zA-Z])(?=.*[0-9])");

  const handleSubmit = (reg) => {
    dispatch(appraisalSlice.actions.setRegistrationInput(reg));

    const regWithoutSpaces = reg.replace(/\s/g, "");
    if (
      hasLettersAndNumbers.test(regWithoutSpaces) &&
      HPIRegCheck.test(regWithoutSpaces)
    ) {
      const data = getLocalStorage(`_abyc_authToken_${appraisalSessionId}`);
      navigate(
        `/mileage?registration=${regWithoutSpaces}&appraisalSessionId=${appraisalSessionId}&data=${data}`
      );
    } else {
      setError("Enter a valid registration number");
    }
  };

  return (
    <RegInput
      onSubmit={handleSubmit}
      error={error}
      showPrivacyStatement={showPrivacyStatement}
    />
  );
}
